<style>
.zoezi-image img {
    max-width: 100%;
    object-fit: contain;
    vertical-align: middle;
}
</style>

<template>
    <figure v-if="src" class="zoezi-image">
        <zoezi-link :link="link">
            <img :src="imageSource" :alt="alt" :style="imageStyle" :class="classes" v-zoezi-link="link" />
        </zoezi-link>
        <figcaption v-if="caption">{{caption}}</figcaption>
    </figure>
</template>

<script>
export default {
    name: 'zoezi-image',

    zoezi: {
        title: 'Image',
        icon: 'mdi-image'
    },

    props: {
        src: {
            title: 'Image',
            type: String,
            fulltype: 'image'
        },
        link: {
            title: 'Link',
            type: Object,
            fulltype: 'link'
        },
        caption: {
            title: 'Caption',
            type: String
        },
        alt: {
            title: 'Alternative text',
            type: String,
        },
        maxwidth: {
            title: 'Maximum width',
            type: Number,
            fulltype: 'csssize'
        },
        autosize: {
            title: 'Adjust size automatically',
            type: Boolean,
            default: true
        },
        radius: {
            title: 'Corner radius',
            type: String,
            fulltype: 'csssize',
            global: true
        },
        elevation: {
            title: 'Elevation',
            type: Number,
            typeinfo: {
                min: 0,
                max: 24
            },
            global: true
        },
        height: {
            title: 'Height (px)',
            type: Number
        },
        width: {
            title: 'Width (px)',
            type: Number
        }
    },

    watch: {
        src: {
            immediate: true,
            handler() {
                this.updateImageUrl();
            }
        }
    },

    computed: {
        imageStyle() {
            let style = {};
            if (this.maxwidth) {
                style.maxWidth = this.maxwidth;
            }
            if (this.radius) {
                style['border-radius'] = this.radius;
            }
            if (this.height) {
                style['height'] = this.height + 'px';
            }
            if (this.width) {
                style['width'] = this.width + 'px';
            }

            return style;
        },
        classes() {
            let classes = [];
            if (this.elevation) {
                classes.push('elevation-' + this.elevation);
            }
            if (this.link) {
                classes.push('z-clickable');
            }
            return classes;
        }
    },
    data: () => ({
        imageSource: ''
    }),
    methods: {
        updateImageUrl() {
            if (this.$el) {
                this.setImageUrl();
            } else {
                this.$nextTick(this.setImageUrl);
            }
        },
        setImageUrl() {
            if (!this.$el) {
                return;
            }
            let maxWidth = null;
            if (this.width || this.autosize) {
                maxWidth = this.width || this.$el.offsetWidth;
                for (let w of this.$api.thumbnailSizes.concat([null])) {
                    if (maxWidth <= w || !w) {
                        maxWidth = w;
                        break;
                    }
                }
            }
            this.imageSource = this.$api.getImageUrl(this.src, maxWidth);
        }
    }
}
</script>
